





























import {Component, Emit, Model, Prop, PropSync, Vue} from "vue-property-decorator";
import {buildRequestHeader} from "@/shared/services/helper/utils";

function getBase64(img: any, callback: any) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}
@Component({
    name: "UploadImage"
})

export default class extends Vue {
    @Prop({ default: '100', type: String })
    readonly width!: string;
    @Prop({ default: '100', type: String })
    readonly height!: string;
    @Prop({ default: "avatar", type: String })
    readonly folder!: string;
    @Prop({ default: "avatar", type: String })
    readonly type!: string;
    @PropSync("imageUrl", { type: String, default: "" })
    syncImageUrl!: string;

    @Model("change")
    image!: string;

    @Emit('change')
    handleChange(info: any) {
        if (info.file.status === 'uploading') {
            this.loading = true;
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, (imageUrl: any) => {
                this.syncImageUrl = imageUrl;
                this.loading = false;
            });
            return info.file.response.data.path;
        }

    }
    previewVisible = false;
    previewImage = '';
    loading = false;
    headers = buildRequestHeader(false as any);
    action = `${process.env.VUE_APP_BASE_API}v1/upload/by-file`;
    params = {
        folder: this.folder
    };
    styleImg = {
        width: `${this.width}${this.width.includes("%") ? '' : 'px'}`,
        height: `${this.height}${this.height.includes("%") ? '' : 'px'}`
    };
    beforeUpload(file: any) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            this.$message.error('You can only upload JPG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            this.$message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }
    handleCancel() {
        this.previewVisible = false;
    }
    async handlePreview(file: any) {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj, () => ({}));
        }
        this.previewImage = file.url || file.preview;
        this.previewVisible = true;
    }
}
